enum InterventionCategoryFieldNames {
  Id = 'id',
  Color = 'color',
  Name = 'name',
  Description = 'description',
}

export default InterventionCategoryFieldNames;
